<template>
  <div class="main">
    <Title>Welcome to <LogoText /></Title>
    <p>
      Want to know what <LogoText /> is about?
      <router-link :to="{ name: 'about' }">Click here!</router-link>
    </p>
    <p class="caption">
      Although there are some things you can do without logging in, I encourage
      you to register a user account and identify yourself in order to use all
      of the features of <LogoText />.
    </p>
    <LoginForm />
  </div>
</template>

<script>
import LoginForm from "@/components/LoginForm.vue";

export default {
  name: "Home",
  components: {
    LoginForm
  }
};
</script>

<style scoped>
.main {
  max-width: 400px;
  margin: 0px auto;
}
a {
  font-weight: bolder;
}
.caption {
  color: #555;
}
</style>
